import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

export class ContactInteractionService {
  static ENDPOINT = `${BASE}/contactInteraction`;

  static async get(contact) {
    return await request({
      url: `${this.ENDPOINT}/`,
      method: 'POST',
      headers: {'Accept': 'application/json'},
      body: contact
    })
  }
}

export default ContactInteractionService;
